import React from "react";
import {
  Box,
  CloseButton,
  Flex,
  LoadingOverlay,
  Paper,
  Text,
  Drawer,
  Card,
} from "@mantine/core";
import { DrawerHeader } from "./DrawerHeader";

export interface IDrawerEditorProps {
  children?: React.ReactNode;
  loading?: boolean;
  onClose?(): void;
}

export const DrawerEditor = (props: IDrawerEditorProps) => {
  const { children, loading, onClose } = props;

  let header;
  let content: any = [];

  React.Children.forEach(children, (child) => {
    if (!React.isValidElement(child)) return;
    if (child.type === DrawerHeader) {
      header = child;
    } else {
      content.push(child);
    }
  });

  return (
    <>
      {!!header && (
        <Drawer.Header
          p={0}
          h="auto"
          mih={50}
          sx={() => ({
            alignItems: "start",
          })}
        >
          <Paper
            radius={0}
            sx={(theme) => ({
              width: "100%",
              alignItems: "start",
              backgroundColor:
                theme.colorScheme === "dark"
                  ? theme.colors.dark[5]
                  : theme.colors.gray[0],
            })}
          >
            <Card.Section withBorder py="md" px="sm">
              <Flex justify="space-between" align="center">
                <Text tt="uppercase" fw={500} fz="xs" lineClamp={1}>
                  {header}
                </Text>
                <CloseButton onClick={() => onClose?.()} />
              </Flex>
            </Card.Section>
          </Paper>
        </Drawer.Header>
      )}
      <LoadingOverlay visible={loading ?? false} />
      <Box sx={{ height: "100%", position: "relative" }}>{content}</Box>
    </>
  );
};

DrawerEditor.displayName = "@modir/ui-mantine/DrawerEditor";
